import { Component, EventEmitter, Input, Output } from "@angular/core";
import { AddressData } from "../../data-types/user-data";

@Component({
    selector: 'app-address',
    templateUrl: './address.component.html',
    styleUrls: ['./address.component.scss']
})
export class AddressComponent {
    @Input() address;
    @Output() next = new EventEmitter();

    validAddress = false;

    constructor() { }

    onSubmit()
    {
        this.next.emit();
    }

    validAddressAdded(adr?: AddressData)
    {
       
        this.validAddress = false;
        if (adr) {
            this.address = { ...this.address, ...adr };

            this.validAddress = true;
        }
       
    }
}
